import { render, staticRenderFns } from "./AudienceDialog.vue?vue&type=template&id=64be6f97&scoped=true"
import script from "./AudienceDialog.vue?vue&type=script&lang=js"
export * from "./AudienceDialog.vue?vue&type=script&lang=js"
import style0 from "./AudienceDialog.vue?vue&type=style&index=0&id=64be6f97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64be6f97",
  null
  
)

export default component.exports